import ServicePage from "./page";
import { termInsuranceData } from "@/mocks/insurancePages";

export default function TermInsurance() {
  return <ServicePage data={termInsuranceData} />;
}